module.exports = __webpack_public_path__ + "static/media/TT-Norms-Pro-Normal.1a2ffa72.ttf";